import ParameterErrors from '../errors/ParameterErrors';
import Vector2 from '../geometry/Vector2';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitBirdsEyeViewOutside360MarkerPosition{
	constructor(props){
		const {outside360UniqueId, markerPosition}=props;
		if(outside360UniqueId===undefined||outside360UniqueId===null)
			throwNotProvided('outside360UniqueId');
		this._outside360UniqueId = outside360UniqueId;
		if(markerPosition===undefined||markerPosition===null)
			throwNotProvided('markerPosition');
		this._markerPosition = markerPosition;
	}
	get markerPosition(){
		return this._markerPosition;
	}
	get outside360UniqueId(){
		return this._outside360UniqueId;
	}
	static fromJSON(jObject){
		return new SiteJsonUnitBirdsEyeViewOutside360MarkerPosition({
			outside360UniqueId:jObject.outside360UniqueId,
			markerPosition:jObject.markerPosition?Vector2.fromObj(jObject.markerPosition):null
		});
	}
}